import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VRow,{staticClass:"dict_input ma-1"},[_c(VCol,[_c('div',_vm._l((Object.entries(Object.assign({}, _vm.value))),function(ref){
var key = ref[0];
var val = ref[1];
return _c('div',[_c('Input',{attrs:{"name":key,"readonly":_vm.readonly,"value":val,"roles":_vm.roles},on:{"update":function (new_val,new_key) {_vm.update(key,new_val,new_key)},"delete":function($event){return _vm.delete_prop(key)}}})],1)}),0),(!_vm.readonly)?_c('AddValue',{attrs:{"dict_value":""},on:{"submit":_vm.update_add}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }